import { useReveal } from '../hooks/useReveal';
import ContactForm from './ContactForm';
import MaterialIcon from './MaterialIcon';

export default function Contact() {
  const [ref, visible] = useReveal();

  return (
    <section id="contact" className="ca-section ca-section--cta" ref={ref} data-analytics-section="contact">
      <div className="ca-container">
        <div className={`ca-cta ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}>
          <div className="ca-cta__copy">
            <p className="ca-eyebrow">Let&apos;s build</p>
            <h2 className="ca-section-title">Tell us what you&apos;re shipping next</h2>
            <p className="ca-section-lead ca-cta__lead">
              From bold startups to global enterprises—we help you move from where you are to where
              you&apos;re meant to be.
            </p>
          </div>
          <div className="ca-cta__panel">
            <ContactForm />
            <p className="ca-cta__hint ca-cta__hint--after-form">
              <MaterialIcon name="mail" variant="pulse" className="ca-cta__hint-icon" />
              Prefer email?
            </p>
            <a className="ca-cta__email" href="mailto:hello@crimsonarctechnologies.online">
              <MaterialIcon name="alternate_email" variant="float" className="ca-cta__email-icon" />
              hello@crimsonarctechnologies.online
            </a>
            <p className="ca-cta__note">
              <MaterialIcon name="language" variant="drift" className="ca-cta__note-icon" />
              <a className="ca-cta__site" href="https://crimsonarctechnologies.online">
                crimsonarctechnologies.online
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
